'use strict';

/**
 * Rearranges color swatch buttons dynamically based on the window size.
 *
 * - On small screens (< 1200px): Shows first 7 swatches, hides the rest.
 * - On large screens (>= 1200px): Shows first 9 swatches, hides the rest in rows of 10.
 *
 * Only shows the toggle when swatches exceed the threshold.
 *
 * Triggers on: load, resize, orientationchange.
 */
function rearrangeColorSwatches() {
    let lastWidth = 0;
    let lastHeight = 0;

    /**
     * Updates the layout for a single bonus product item.
     * @param {jQuery} $item - The bonus-product-item container
     */
    function updateItemLayout($item) {
        const $swatchGroup = $item.find('.swatch-display-group').first();
        let $hiddenGroup = $item.find('.swatch-hidden-group').first();
        const $toggleWrapper = $item.find('.remain-swatch-wrapper').first();

        if (!$swatchGroup.length) return;

        // Create hidden group if it doesn't exist
        if (!$hiddenGroup.length) {
            $hiddenGroup = $('<div class="swatch-hidden-group"></div>');
            $swatchGroup.after($hiddenGroup);
        }


        const $allButtons = $swatchGroup.find('button.color-attribute')
            .add($hiddenGroup.find('button.color-attribute'));
        const totalSwatches = $allButtons.length;

        const currentWidth = window.innerWidth;
        const toggleThreshold = currentWidth < 1200 ? 7 : 9;
        const visibleCount = currentWidth < 1200 ? 7 : 9;

        $swatchGroup.find('button.color-attribute').remove();
        $hiddenGroup.empty();

        const $visible = $allButtons.slice(0, visibleCount);
        const $hidden = $allButtons.slice(visibleCount);

        $swatchGroup.prepend($visible);

        if ($hidden.length > 0) {
            if (currentWidth >= 1200) {
                for (let i = 0; i < $hidden.length; i += 10) {
                    const $row = $('<div class="swatch-row"></div>');
                    $row.append($hidden.slice(i, i + 10));
                    $hiddenGroup.append($row);
                }
                $item.find('.swatch-row').css({ display: 'flex', 'flex-wrap': 'nowrap' });
            } else {
                $hiddenGroup.append($hidden);
            }
        }

        if (totalSwatches > toggleThreshold && $toggleWrapper.length) {
            $toggleWrapper
                .attr('aria-expanded', 'false')
                .attr('tabindex', '0')
                .attr('aria-hidden', null)
                .css('display', 'block')
                .removeClass('d-none');
            if (!$swatchGroup.find('.remain-swatch-wrapper').length) {
                $swatchGroup.append($toggleWrapper);
            }
        } else if ($toggleWrapper.length) {
            $toggleWrapper.addClass('d-none').attr('aria-hidden', 'true').attr('tabindex', '-1').css('display', 'none');
           
            const $firstHidden = $hiddenGroup.find('button.color-attribute.circle-button').first();
            if ($firstHidden.length) {
                $firstHidden.detach();
                $swatchGroup.append($firstHidden);
            }
        }
    }

    /**
     * Updates layout for all bonus product items when window size changes.
     */
    function updateLayout() {
        const currentWidth = window.innerWidth;
        const currentHeight = window.innerHeight;

        if (currentWidth === lastWidth && currentHeight === lastHeight) return;

        lastWidth = currentWidth;
        lastHeight = currentHeight;

        $('.choose-bonus-product-dialog .bonus-product-item').each(function () {
            updateItemLayout($(this));
        });
    }

    // Initial call
    updateLayout();

    // Event listeners
    ['load', 'resize', 'orientationchange'].forEach(eventType => {
        window.addEventListener(eventType, updateLayout);
    });
}

module.exports = {
    rearrangeColorSwatchesinModal: rearrangeColorSwatches
};